import { StatusDot } from "@/components/campaigns/CampaignStatusChip";
import { CAMPAIGN_STATUSES } from "@/constants/campaings";
import type { SendQueueItem } from "@/interfaces/sendQueueCampaigns";
import { formatAbsolute, formatRelative } from "@/utils/sendQueueCampaigns-helper";

interface ScheduledCellProps {
  item: SendQueueItem;
}

/**
 * Two-line "Scheduled" cell for the Send Queue table (GFG-194, unit U9). Line 1 is the relative
 * time (weight 600, rodeo-black) -- "Sending now" while the row is `status: "Sending"`, else a
 * delta from `formatRelative`, with a small pulsing dot next to it while the send is in flight.
 * Line 2 is the absolute local time (12px, graphite) from `formatAbsolute`. Neither string is
 * computed here; both come from sendQueueCampaigns-helper.ts.
 */
export default function ScheduledCell({ item }: ScheduledCellProps) {
  const isSending = item.status === CAMPAIGN_STATUSES.QUEUE_SENDING;

  return (
    <div>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontWeight: 600,
          color: "var(--color-rodeo-black)",
        }}
      >
        {isSending && <StatusDot size={6} color="var(--color-good-night)" pulse />}
        {formatRelative(item.scheduledAt, Date.now(), item.status)}
      </div>
      <div style={{ fontSize: 12, color: "var(--color-graphite)", marginTop: 2 }}>
        {formatAbsolute(item.scheduledAt)}
      </div>
    </div>
  );
}
